/**
 * Legacy UserPreferencesApiService module — preserved as an empty AngularJS
 * module so existing dependencies (`acme.common.service.userPreferencesApi`)
 * keep resolving.
 *
 * The actual UserPreferencesApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/user-preferences/user-preferences-api.service.ts
 */
angular.module("acme.common.service.userPreferencesApi", [
  "acme.common.factory.apiVersion",
]);
